//translate
import i18n from "../../translate/i18n"

//component
import ContactSection from "../../Component/ContactSection"

const Contact = () => {
  return (
    <div  dir={i18n.language === "en" ? "ltr" : "rtl"} className="py-10 bg-[#223C61] text-primaryColor mt-10 min-h-[70vh]">
    <ContactSection/>
    </div>
  )
}

export default Contact
